export const inputIds = {
    reportName: 'report-name',
};
